import { gql } from "@apollo/client";

export const SEND_MESSAGE = gql`
    mutation sendMessage($chatId: ID!, $content: String!, $attachments: [MessageAttachmentInput!]) {
        sendMessage(chatId: $chatId, content: $content, attachments: $attachments) {
            id
            createdAt
            content
            type
            senderId
            chatId
            attachments {
                fileName
                tokens
                fileSize
            }
        }
    }
`;
